module.exports = "<app-profile-users *ngIf=\"tab === ProfileDetails.USERS\"></app-profile-users>\r\n<app-profile-house *ngIf=\"tab === ProfileDetails.HOUSE\"></app-profile-house>\r\n<app-profile-details *ngIf=\"tab === ProfileDetails.SERVICEDETAILS\"></app-profile-details>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/profile/profile-tab/profile-tab.component.html
// module id = ./src/app/entities/profile/profile-tab/profile-tab.component.html
// module chunks = main